import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button as MuiButton } from '@mui/material';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { useThemeTokens } from '@providers/themeTokenProvider';
import type { FC } from 'react';
import {
  formatApproachingCount,
  formatThresholdSummary,
  WATCH_LIST_COPY,
} from './watchListCopy';

export type WatchListHeaderProps = {
  approachingCount: number;
  expanded: boolean;
  onToggleExpanded: () => void;
  /** The band-consumed percentage threshold, e.g. 75. Used in the summary string. */
  approachThreshold: number;
};

export const WatchListHeader: FC<WatchListHeaderProps> = ({
  approachingCount,
  expanded,
  onToggleExpanded,
  approachThreshold,
}) => {
  const { sys } = useThemeTokens();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        py: 2,
      }}
    >
      {/* Left cluster: title + approaching badge + summary */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1.5,
        }}
      >
        <Typography variant='headingSmall'>{WATCH_LIST_COPY.title}</Typography>

        {/* Approaching count badge — warning/neutral tone, not red */}
        <Box
          sx={{
            px: 1,
            py: 0.25,
            borderRadius: 8,
            backgroundColor: sys.color.warningVariant,
            color: sys.color.onWarningVariant,
          }}
        >
          <Typography variant='labelSmall'>
            {formatApproachingCount(approachingCount)}
          </Typography>
        </Box>

        <Typography variant='bodySmall' colorVariant='variant'>
          {formatThresholdSummary(approachThreshold)}
        </Typography>
      </Box>

      {/* Right cluster: collapse / expand toggle */}
      <MuiButton
        variant='outlined'
        size='small'
        onClick={onToggleExpanded}
        endIcon={
          <ExpandMoreIcon
            sx={{
              transition: 'transform 200ms',
              transform: expanded ? 'rotate(180deg)' : 'none',
            }}
          />
        }
      >
        {expanded
          ? WATCH_LIST_COPY.header.collapse
          : WATCH_LIST_COPY.header.expand}
      </MuiButton>
    </Box>
  );
};
